/**
 * PDF 다운로드 관련 로직을 담당하는 model
 */

/**
 * fileId를 받아서 PDF 다운로드 URL로 리다이렉트하는 함수
 * @param {string} fileId - PDF 파일 ID
 */
export const downloadPdfByFileId = (fileId) => {
  const downloadUrl = `${process.env.REACT_APP_API_DFD_SVC_URL}/dfd/api/if/web/v1/pay-detail-statement-download/${fileId}`;
  window.location.href = downloadUrl;
};

/**
 * PDF 다운로드 훅
 * @returns {Object} downloadPdf - 다운로드 함수
 */
export const usePdfDownload = () => {
  const downloadPdf = (fileId) => {
    downloadPdfByFileId(fileId);
  };

  return { downloadPdf };
};
